import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";
import { heroImage } from "@/mocks/images";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[560px] items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src={heroImage}
        alt="AllChinaBuy Spreadsheet 2026"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40" />

      <div className="relative z-10 w-full px-4 py-16 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur">
          <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center" />
          {t("hero.badge")}
        </span>

        <h1 className="mx-auto mt-6 max-w-4xl font-heading text-4xl font-bold leading-tight text-white md:text-6xl">
          {t("hero.title")}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-7 py-3.5 text-base font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-grid-line w-5 h-5 flex items-center justify-center" />
            {t("hero.ctaSpreadsheet")}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 rounded-full border border-white/50 bg-white/10 px-7 py-3.5 text-base font-semibold text-white whitespace-nowrap backdrop-blur transition-colors hover:bg-white/20"
          >
            <i className="ri-shopping-bag-3-line w-5 h-5 flex items-center justify-center" />
            {t("hero.ctaBuy")}
          </a>
        </div>

        <Link
          to="/allchinabuy-spreadsheet-guide"
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-white/90 transition-colors hover:text-white"
        >
          {t("hero.ctaGuide")}
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
        </Link>
      </div>
    </section>
  );
}